module.exports = __webpack_public_path__ + "assets/img/表格.860ad328.svg";